export default "__VITE_ASSET__CQoH6Xn5__"